import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faPenToSquare, faEye, faEyeSlash, faUserGroup, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Navigation from '../../../Layouts/Navigation/Navigation';
import { BASE_URL } from '../../../utils/constants';

function AdminAdministrators() {
  const navigate = useNavigate();
  const [administradores, setAdministradores] = useState([]);
  const [filteredAdministradores, setFilteredAdministradores] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);

  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [usuario, setUsuario] = useState("");
  const [identificacion, setIdentificacion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [selectedUser, setSelectedUser] = useState(null);
  const [editOpen, setEditOpen] = useState(false);

  const [openSnack, setOpenSnack] = useState(false);
  const [snackStatus, setSnackStatus] = useState("");
  const [snackMessage, setSnackMessage] = useState("");

    const handleClickSnack = () => {
        setOpenSnack(true);
    };

    const handleCloseSnack = () => {
        setOpenSnack(false);
    };
  
    const handleClose = () => {
        setOpen(false);
        clearForm();
    };

    const clearForm = () => {
        setNombre("");
        setApellido("");
        setEmail("");
        setUsuario("");
        setIdentificacion("");
        setTelefono("");
        setPassword("");
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getAdministrators();
    }, []);

    useEffect(() => {
        if (openSnack) {
            const timer = setTimeout(() => {
                setOpenSnack(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [openSnack]);

    const getAdministrators = () => {
        axios.get(`${BASE_URL}/administrators`)
            .then((response) => {
                setAdministradores(response.data);
                setFilteredAdministradores(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
        const filtered = administradores.filter((admin) =>
            admin.nombre.toLowerCase().includes(value) ||
            admin.apellido.toLowerCase().includes(value) ||
            admin.email.toLowerCase().includes(value) ||
            admin.usuario.toLowerCase().includes(value) ||
            admin.identificacion.toString().includes(value)
        );
        setFilteredAdministradores(filtered);
        setPage(0);
    };

    const handleAddSubmit = (event) => {
        event.preventDefault();
        
        const adminData = {
            nombre,
            apellido,
            email,
            usuario,
            identificacion,
            telefono,
            password
        };

        axios.post(`${BASE_URL}/addAdministrator`, adminData)
            .then((response) => {
                if (response.status === 200) {
                    setSnackStatus("success");
                    setSnackMessage("Administrador agregado con éxito.");
                    getAdministrators();
                    handleClose();
                } else if (response.status === 500) {
                    setSnackStatus("error");
                    setSnackMessage("Error al agregar el administrador.");
                }
                handleClickSnack();
            })
            .catch((error) => {
                console.log(error);
                setSnackStatus("error");
                setSnackMessage("Error al guardar el administrador.");
                handleClickSnack();
            });
    };

    const handleEditSubmit = (event) => {
        event.preventDefault();
        
        const adminData = {
            id_usuario: selectedUser.id_usuario,
            nombre: selectedUser.nombre,
            apellido: selectedUser.apellido,
            email: selectedUser.email,
            usuario: selectedUser.usuario,
            identificacion: selectedUser.identificacion,
            telefono: selectedUser.telefono,
            id_estado: selectedUser.id_estado
        };

        axios.put(`${BASE_URL}/updateAdministrator/${selectedUser.id_usuario}`, adminData)
            .then((response) => {
                if (response.status === 200) {
                    setSnackStatus("success");
                    setSnackMessage("Administrador actualizado con éxito.");
                    getAdministrators();
                    setEditOpen(false);
                } else if (response.status === 500) {
                    setSnackStatus("error");
                    setSnackMessage("Error al actualizar el administrador.");
                }
                handleClickSnack();
            })
            .catch((error) => {
                console.log(error);
                setSnackStatus("error");
                setSnackMessage("Error al actualizar el administrador.");
                handleClickSnack();
            });
    };

  return (
    <>
        <Navigation/>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">
                {/* Snackbar */}
                {openSnack && (
                    <div className="fixed top-4 right-4 z-[9999] animate-slide-in">
                        <div className={`rounded-lg shadow-lg p-4 ${
                            snackStatus === 'success' ? 'bg-green-500' : 'bg-red-500'
                        } text-white flex items-center gap-3 min-w-[300px]`}>
                            <span>{snackMessage}</span>
                            <button onClick={handleCloseSnack} className="ml-auto text-white hover:text-gray-200">
                                ✕
                            </button>
                        </div>
                    </div>
                )}

                {/* Header */}
                <div className="flex items-center justify-between mb-10">
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="flex items-center gap-2 bg-white hover:bg-gray-100 text-gray-700 px-4 py-2 rounded-lg shadow-md transition-all"
                    >
                        <FontAwesomeIcon icon={faArrowLeft} className="h-5 w-5" />
                        Volver
                    </button>
                    <div className="flex items-center">
                        <FontAwesomeIcon icon={faUserGroup} className="h-10 w-10 text-primary-600 mr-3" />
                        <h1 className="text-4xl font-bold text-gray-800">
                            Administración de Administradores
                        </h1>
                    </div>
                    <div className="w-24"></div>
                </div>

                {/* Search and Add Button */}
                <div className="mb-6 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
                    <div className="flex-1 max-w-md">
                        <input
                            type="text"
                            placeholder="Buscar por nombre, apellido, email, usuario o identificación..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                        />
                    </div>
                    <button
                        onClick={() => setOpen(true)}
                        className="flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white px-6 py-3 rounded-lg shadow-md transition-all duration-200 hover:shadow-lg whitespace-nowrap"
                    >
                        <FontAwesomeIcon icon={faUserPlus} className="h-5 w-5" />
                        Agregar Administrador
                    </button>
                </div>

                {/* Add Modal */}
                {open && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
                            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-2xl">
                                <h2 className="text-2xl font-bold text-gray-800">Agregar Administrador</h2>
                                <p className="text-gray-600 mt-1">Por favor, ingrese los datos del nuevo administrador.</p>
                            </div>
                            
                            <form onSubmit={handleAddSubmit} className="p-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Nombre *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={nombre}
                                            onChange={(e) => setNombre(e.target.value)}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Apellido *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={apellido}
                                            onChange={(e) => setApellido(e.target.value)}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Email *
                                        </label>
                                        <input
                                            type="email"
                                            required
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Usuario *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={usuario}
                                            onChange={(e) => setUsuario(e.target.value)}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Identificación *
                                        </label>
                                        <input
                                            type="number"
                                            required
                                            value={identificacion}
                                            onChange={(e) => setIdentificacion(e.target.value)}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Teléfono *
                                        </label>
                                        <input
                                            type="number"
                                            required
                                            value={telefono}
                                            onChange={(e) => setTelefono(e.target.value)}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Contraseña *
                                        </label>
                                        <div className="relative">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                required
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent pr-12"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => setShowPassword(!showPassword)}
                                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                            >
                                                {showPassword ? <FontAwesomeIcon icon={faEyeSlash} className="h-5 w-5" /> : <FontAwesomeIcon icon={faEye} className="h-5 w-5" />}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex gap-3 justify-end mt-6">
                                    <button
                                        type="button"
                                        onClick={handleClose}
                                        className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="submit"
                                        className="px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors"
                                    >
                                        Registrar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* Edit Modal */}
                {editOpen && selectedUser && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
                            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-2xl">
                                <h2 className="text-2xl font-bold text-gray-800">Editar Administrador</h2>
                                <p className="text-gray-600 mt-1">Modifique los datos del administrador.</p>
                            </div>
                            
                            <form onSubmit={handleEditSubmit} className="p-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Nombre *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={selectedUser?.nombre}
                                            onChange={(e) => setSelectedUser({ ...selectedUser, nombre: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Apellido *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={selectedUser?.apellido}
                                            onChange={(e) => setSelectedUser({ ...selectedUser, apellido: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Email *
                                        </label>
                                        <input
                                            type="email"
                                            required
                                            value={selectedUser?.email}
                                            onChange={(e) => setSelectedUser({ ...selectedUser, email: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Usuario *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={selectedUser?.usuario}
                                            onChange={(e) => setSelectedUser({ ...selectedUser, usuario: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Identificación *
                                        </label>
                                        <input
                                            type="number"
                                            required
                                            value={selectedUser?.identificacion}
                                            onChange={(e) => setSelectedUser({ ...selectedUser, identificacion: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Teléfono *
                                        </label>
                                        <input
                                            type="number"
                                            required
                                            value={selectedUser?.telefono}
                                            onChange={(e) => setSelectedUser({ ...selectedUser, telefono: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Contraseña
                                        </label>
                                        <div className="relative">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                value={selectedUser?.password || ''}
                                                onChange={(e) => setSelectedUser({ ...selectedUser, password: e.target.value })}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent pr-12"
                                                placeholder="Dejar vacío para mantener"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => setShowPassword(!showPassword)}
                                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                            >
                                                {showPassword ? <FontAwesomeIcon icon={faEyeSlash} className="h-5 w-5" /> : <FontAwesomeIcon icon={faEye} className="h-5 w-5" />}
                                            </button>
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Estado *
                                        </label>
                                        <select
                                            required
                                            value={selectedUser?.id_estado}
                                            onChange={(e) => setSelectedUser({ ...selectedUser, id_estado: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        >
                                            <option value="1">Activo</option>
                                            <option value="0">Inactivo</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="flex gap-3 justify-end mt-6">
                                    <button
                                        type="button"
                                        onClick={() => setEditOpen(false)}
                                        className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="submit"
                                        className="px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors"
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* Table */}
                <div className="bg-white rounded-2xl shadow-md overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50 border-b border-gray-200">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Nombre
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Apellido
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Email
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Usuario
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Identificación
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Teléfono
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Estado
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Acciones
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {filteredAdministradores.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((adminItem) => (
                                    <tr key={adminItem.id_usuario} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {adminItem.nombre}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {adminItem.apellido}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {adminItem.email}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {adminItem.usuario}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {adminItem.identificacion}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {adminItem.telefono}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                                adminItem.id_estado === 1 
                                                    ? 'bg-green-100 text-green-800' 
                                                    : 'bg-red-100 text-red-800'
                                            }`}>
                                                {adminItem.id_estado === 1 ? 'Activo' : 'Inactivo'}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                                            <button
                                                onClick={() => {
                                                    setSelectedUser({ ...adminItem, password: "" });
                                                    setEditOpen(true);
                                                }}
                                                className="text-primary-600 hover:text-primary-900 transition-colors"
                                                title="Editar"
                                            >
                                                <FontAwesomeIcon icon={faPenToSquare} className="h-5 w-5" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                        <div className="flex-1 flex justify-between sm:hidden">
                            <button
                                onClick={() => setPage(page - 1)}
                                disabled={page === 0}
                                className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Anterior
                            </button>
                            <button
                                onClick={() => setPage(page + 1)}
                                disabled={page >= Math.ceil(administradores.length / rowsPerPage) - 1}
                                className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Siguiente
                            </button>
                        </div>
                        <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                            <div>
                                <p className="text-sm text-gray-700">
                                    Mostrando <span className="font-medium">{page * rowsPerPage + 1}</span> a{' '}
                                    <span className="font-medium">
                                        {Math.min((page + 1) * rowsPerPage, filteredAdministradores.length)}
                                    </span>{' '}
                                    de <span className="font-medium">{filteredAdministradores.length}</span> resultados
                                </p>
                            </div>
                            <div className="flex items-center gap-4">
                                <select
                                    value={rowsPerPage}
                                    onChange={(e) => {
                                        setRowsPerPage(parseInt(e.target.value, 10));
                                        setPage(0);
                                    }}
                                    className="px-3 py-1 border border-gray-300 rounded-md text-sm"
                                >
                                    <option value={5}>5 por página</option>
                                    <option value={10}>10 por página</option>
                                    <option value={25}>25 por página</option>
                                </select>
                                <div className="flex gap-2">
                                    <button
                                        onClick={() => setPage(page - 1)}
                                        disabled={page === 0}
                                        className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Anterior
                                    </button>
                                    <button
                                        onClick={() => setPage(page + 1)}
                                        disabled={page >= Math.ceil(filteredAdministradores.length / rowsPerPage) - 1}
                                        className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Siguiente
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default AdminAdministrators

